/* eslint-disable react-hooks/static-components */
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import { Tooltip } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import {
  ObjectFieldTemplateProps,
  RJSFSchema,
  StrictRJSFSchema,
  canExpand,
  descriptionId,
  getTemplate,
  getUiOptions,
  titleId,
} from '@rjsf/utils';
import { iconButtonPillStyle } from 'components/button/iconButtonPillStyle';
import { ArrayContainer } from './ArrayFieldTemplate.styles';

export default function ObjectFieldTemplate<S extends StrictRJSFSchema = RJSFSchema>(
  props: ObjectFieldTemplateProps<S>,
) {
  const {
    description,
    title,
    properties,
    required,
    disabled,
    readonly,
    uiSchema,
    idSchema,
    schema,
    formData,
    onAddClick,
    registry,
  } = props;
  const uiOptions = getUiOptions(uiSchema);
  const TitleFieldTemplate = getTemplate('TitleFieldTemplate', registry, uiOptions);
  const DescriptionFieldTemplate = getTemplate('DescriptionFieldTemplate', registry, uiOptions);
  const expandable = canExpand<S>(schema, uiSchema, formData);

  const propertiesGrid = (
    <Grid container={true} spacing={2} style={{ marginTop: '10px' }}>
      {properties.map((element, index) =>
        element.hidden ? (
          element.content
        ) : (
          <Grid item={true} xs={12} key={index} style={{ marginBottom: '10px' }}>
            {element.content}
          </Grid>
        ),
      )}
      {expandable && (
        <Grid container justifyContent="flex-end">
          <Grid item={true}>
            <Box mt={1.5}>
              <Tooltip title="Add">
                <span style={{ display: 'inline-flex' }}>
                  <IconButton
                    className="object-property-expand"
                    aria-label="add"
                    size="small"
                    sx={iconButtonPillStyle}
                    onClick={onAddClick(schema)}
                    disabled={!!disabled || !!readonly}
                  >
                    <AddIcon fontSize="small" />
                  </IconButton>
                </span>
              </Tooltip>
            </Box>
          </Grid>
        </Grid>
      )}
    </Grid>
  );

  const header = (
    <>
      {title && (
        <TitleFieldTemplate
          id={titleId(idSchema)}
          title={title}
          required={required}
          schema={schema}
          uiSchema={uiSchema}
          registry={registry}
        />
      )}
      {description && (
        <DescriptionFieldTemplate
          id={descriptionId(idSchema)}
          description={description}
          schema={schema}
          uiSchema={uiSchema}
          registry={registry}
        />
      )}
    </>
  );

  return expandable ? (
    <ArrayContainer>
      {header}
      {propertiesGrid}
    </ArrayContainer>
  ) : (
    <>
      {header}
      {propertiesGrid}
    </>
  );
}
